// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"e9c360af","475":"04177521","487":"b175faf3","797":"d5654038","845":"20947b1a"}[chunkId] + ".chunk.js";
};